export enum CustomEventFieldType {
    FreeText = 0,
    SingleSelect = 1,
    MultipleSelect = 2,
    Boolean = 3,
}
